export default __webpack_public_path__ + "static-front/media/PasswordIcon.604ededf.svg";